import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { dispatch as storeDispatch } from '@store';
import { actions } from '@store/modals';

var ModalsServiceClass = /*#__PURE__*/function () {
  function ModalsServiceClass() {
    _classCallCheck(this, ModalsServiceClass);

    _defineProperty(this, "modalIndex", 0);
  }

  _createClass(ModalsServiceClass, [{
    key: "open",
    value: function open(modalId, data) {
      var dispatch = storeDispatch;
      var modalAction = dispatch(actions.modalInit({
        modalId: "".concat(modalId, "___").concat(this.modalIndex),
        data: data,
        isOpen: true
      }));
      this.modalIndex += 1;
      modalAction["catch"](function (error) {
        return error;
      });
      return modalAction;
    }
  }, {
    key: "close",
    value: function close(modalId) {
      storeDispatch(actions.modalInitClosing({
        modalId: modalId
      }));
    }
  }, {
    key: "closeWithAnswer",
    value: function closeWithAnswer(modalId, _ref) {
      var _ref$accepted = _ref.accepted,
          accepted = _ref$accepted === void 0 ? false : _ref$accepted,
          _ref$rejected = _ref.rejected,
          rejected = _ref$rejected === void 0 ? false : _ref$rejected,
          _ref$closeData = _ref.closeData,
          closeData = _ref$closeData === void 0 ? undefined : _ref$closeData;
      storeDispatch(actions.modalInitClosingWithAnswer({
        modalId: modalId,
        accepted: accepted,
        rejected: rejected,
        closeData: closeData
      }));
    }
  }]);

  return ModalsServiceClass;
}();

var ModalsService = new ModalsServiceClass();
export { ModalsService };